import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { orderApi } from '@formosa/shared/api/order';
import { ApiError } from '@formosa/shared/api/request';
import SettingsSubPageShell from '../../components/settings/SettingsSubPageShell';
import { useTranslation } from '../../i18n/LocaleContext';

export default function FollowOrderSignalsPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const symbolParam = searchParams.get('symbol');
  const { t } = useTranslation();

  const [signals, setSignals] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  function buildConfirmPath(followOrderId) {
    const base = `/trade/futures/follow/${followOrderId}`;
    return symbolParam ? `${base}?symbol=${encodeURIComponent(symbolParam)}` : base;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    const value = signals.trim();
    if (!value || submitting) {
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      const page = await orderApi.listFollowOrders({
        pageNo: 1,
        pageSize: 20,
        signals: value,
      });
      const records = page?.records || [];
      if (records.length === 0) {
        setError(t('follow.signalsInvalid'));
        return;
      }
      navigate(buildConfirmPath(records[0].id), {
        state: { followOrder: records[0] },
      });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : t('follow.loadFailed'));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <SettingsSubPageShell title={t('follow.title')}>
      <div className="follow-signals-page">
        <div className="follow-signals-page__hero" aria-hidden>
          <span className="follow-signals-page__lock">🔒</span>
        </div>

        <form className="follow-signals-page__form" onSubmit={handleSubmit}>
          <label className="follow-signals-page__label" htmlFor="followSignals">
            {t('follow.signalsLabel')}
          </label>
          <input
            id="followSignals"
            className="follow-signals-page__input"
            value={signals}
            placeholder={t('follow.signalsPlaceholder')}
            onChange={(event) => setSignals(event.target.value)}
            autoComplete="off"
          />
          {error && <p className="follow-signals-page__error">{error}</p>}
          <button
            type="submit"
            className="follow-signals-page__submit"
            disabled={!signals.trim() || submitting}
          >
            {submitting ? t('common.loading') : t('follow.submit')}
          </button>
        </form>
      </div>
    </SettingsSubPageShell>
  );
}
